console.log('InteliaApp...');

const InteliaApp = {

    init: function () {
        console.log('InteliaApp iniciando...');

        //console.log(window.ShopifyAnalytics);

        InteliaApp.params.customer_id = InteliaApp.getParameter('customer_id');
        InteliaApp.params.product_id = InteliaApp.getParameter('product_id');
        InteliaApp.params.collection_id = InteliaApp.getParameter('collection_id');
    },

    cartLoaded: false,

    getParameter: function (key) {
        
        switch (key) {

            case 'customer_id':

                try {
                    let curr = window.ShopifyAnalytics.meta.page.customerId;
                    if (curr !== undefined && curr !== null && curr !== "") {
                        return curr;
                    }
                } catch (e) { }
                try {
                    let curr = window.meta.page.customerId;
                    if (curr !== undefined && curr !== null && curr !== "") {
                        return curr;
                    }
                } catch (e) { }
                try {
                    let curr = __st.cid;
                    if (curr !== undefined && curr !== null && curr !== "") {
                        return curr;
                    }
                } catch (e) { }
                try {
                    let curr = ShopifyAnalytics.lib.user().traits().uniqToken;
                    if (curr !== undefined && curr !== null && curr !== "") {
                        return curr;
                    }
                } catch (e) { }



                return null;

                break;

            case 'product_id':

                if (window.ShopifyAnalytics != undefined && window.ShopifyAnalytics.meta != undefined) {
                    if ('product' in window.ShopifyAnalytics.meta) {
                        let curr = window.ShopifyAnalytics.meta.product.id;
                        if (curr !== undefined && curr !== null && curr !== "") {
                            return curr;
                        }
                    }
                }

                if (__st.rid != undefined && __st.p == 'product') {
                    let curr = __st.rid;
                    if (curr !== undefined && curr !== null && curr !== "") {
                        return curr;
                    }
                }

                return null;

                break;

            case 'collection_id':
                try {
                    if (window.ShopifyAnalytics != undefined && window.ShopifyAnalytics.meta.page.resourceType == 'collection') {
                        let colec = window.ShopifyAnalytics.meta.page.resourceId;

                        if (colec !== undefined && colec !== null && colec !== "") {
                            return colec;
                        }

                    }

                    if (__st.rid != undefined && __st.p == 'collection') {
                        let colec = __st.rid;

                        if (colec !== undefined && colec !== null && colec !== "") {
                            return colec;
                        }
                    }
                } catch (e) {

                }
                return '';
                break;

        }

    },

    params: {
        products: null,
        customer_id: null,
        product_id: null,
        collection_id: null,
        ip: null,
        token: null,
    },

    relatedBlocks: {

        hide: function (list) {
            console.log('Oculta el bloque de recomendaciones HtmlId: ' + list.id);
            list.style.display = "none";
        },

        show: function (id, list, limit) {
            console.log('Muestra el bloque de recomendaciones HtmlId: ' + list.id + '(ID recomendador : ' + id + ')');
            
            let together = false;

            if (list.classList.contains('intelia-block-together')) {
                together = true;
                // do some stuff
            }

            let carrousel = list.dataset.carrousel;

            var baseUrl = 'https://cdp.plataformaintelia.com/intelia-shopify/public/store/2/recommendations/' + id;
            var request = new XMLHttpRequest();
            var p_customerId = InteliaApp.params.customer_id ? InteliaApp.params.customer_id : '';
            var p_productId = InteliaApp.params.product_id ? InteliaApp.params.product_id : '';
            var p_familyId = InteliaApp.params.collection_id ? InteliaApp.params.collection_id : '';
            var token = InteliaApp.params.token;
            
            //request.open("GET", baseUrl + "?customer=" + p_customerId + "&products[]=" + p_productId + "&limit=" + limit);
            // const recommendationsUrl = baseUrl + "?shopihost=" + window.location.hostname+InteliaApp.params.products + "&token="+token+"&family="+p_familyId+"&customer=" + p_customerId + "&current_prod=" + p_productId + "&limit=" + limit+ "&carrousel=" + carrousel);
            const recommendationsUrl = baseUrl + "?shopihost=" + Shopify.shop + InteliaApp.params.products + "&token=" + token + "&family=" + p_familyId + "&customer=" + p_customerId + "&current_prod=" + p_productId + "&limit=" + limit + "&carrousel=" + carrousel;
            console.log('recommendationsUrl:', recommendationsUrl);
            request.open("GET", recommendationsUrl);

            request.onload = function () {
                if (request.status === 404 || request.status === 422) {
                    console.log('Error en la respuesta de CDP: ' + request.status);
                    return InteliaApp.relatedBlocks.hide(list);
                }

                let products = [];

                const response = JSON.parse(request.response);
                if (response.success) {
                    console.log('CDP ha respondido correctamente');
                    console.log(response);

                    products = response.data;

                    if (products.length === 0 || (products.length === 1 && Object.keys(products[0]).length === 0)) {
                        return InteliaApp.relatedBlocks.hide(list);
                    }
                    
                } else {
                    console.log('Error en la respuesta de CDP');
                    console.log(response);
                }

                if (!together) {
                    console.log('Not FBT block: empty HTML content');
                    list.innerHTML = '';
                }

                const size = products.length;
                let loadedCount = 0;

                Object.entries(products).forEach(([key, value]) => {
                    console.log('Loading product ' + key + ' : ' + value.url);
                    if (!together || key == 0) {

                        let block = '<div style="display:none" id="' + key + '"></div>';

                        if (together) {
                            list.innerHTML = block + list.innerHTML;
                        } else {
                            list.innerHTML = list.innerHTML + block;
                        }

                        const xhr = new XMLHttpRequest();
                        xhr.open('GET', value.url + "?view=intelia", true);
                        xhr.onload = function () {

                            loadedCount++;

                            const status = xhr.status;
                            console.log('Request status for item product: ' + status);
                            if (status === 200) {
                                var currentProductElement = '<div style="display:none" id="int' + p_productId + '">PROD_ACTUAL</div>';
                                if (together) {
                                    list.innerHTML = list.innerHTML.replace(block, xhr.response + '<span class="together_plus">+</span>' + currentProductElement);
                                }
                                else {
                                    list.innerHTML = list.innerHTML.replace(block, xhr.response);

                                }

                                // When in block "Frequently Bought Together" (FBT) also append the initial product
                                if (together) {

                                    console.log("Loading current product for FBT");

                                    const url = value.url + ".js"

                                    console.log("URL for FBT request: " + url);

                                    fetch(url)
                                    .then(res => res.json())
                                    .then(function (data) {

                                        // Get initial product for FBT

                                        var separator = '?';
                                        if (window.location.href.includes(separator)) {
                                            separator = '&';
                                        }
                                        const initialProductURL = window.location.href + separator + 'view=intelia';

                                        //list.innerHTML = list.innerHTML;

                                        var xhrori = new XMLHttpRequest();
                                        xhrori.open('GET', initialProductURL, true);
                                        xhrori.onload = function () {
                                            const status = xhr.status;
                                            console.log('Request status for FBT product: ' + status);
                                            if (status === 200) {

                                                // console.log(list);
                                                // console.log(xhrori.response);

                                                // Create a new div element from the response
                                                var div = document.createElement('div');
                                                div.innerHTML = xhrori.response.trim();

                                                list.innerHTML = list.innerHTML.replace(currentProductElement, xhrori.response);

                                                const int_productId = document.getElementById('int' + p_productId);
                                                if (int_productId != null) {
                                                    int_productId.replaceWith(div.firstChild);
                                                }

                                                const togetherButtons = document.querySelector(".intelia-together-button");
                                                if (togetherButtons) {
                                                    InteliaApp.relatedBlocks.initBuyTogetherButton(togetherButtons, data);
                                                } else {
                                                    console.log('There is no "Buy together" button present');
                                                }

                                            }
                                        };
                                        xhrori.send();
                                    });
                                }   

                            }
                            else {
                                list.innerHTML = list.innerHTML.replace(block, '');
                            }
                            console.log('Loaded items: ' + loadedCount + ' of ' + size);

                            if (loadedCount == size && !together) {
                                console.log('ID recomendador: ' + id);
                                /*
                                var flkty = new Flickity( '.intelia-block-' + id, {
                                    // options
                                    cellAlign: 'left',
                                    contain: true,
                                    pageDots: false,
                                    prevNextButtons: false,
                                    wrapAround: false,
                                });
                                */
                            }

                        };
                        xhr.send();
                    }
                });

                // Append product recommendations to the DOM.
                // list.innerHTML = products.map(function(product) { return InteliaApp.renderProduct(product) }).join("");
            };

            request.onerror = function () {
                InteliaApp.relatedBlocks.hide(list);
            };

            // Send AJAX request
            request.send();

        },

        initBuyTogetherButton: function (element, data) {
            console.log('Adding listener to "Buy together" button');
            element.addEventListener("click", function () {

                console.log('Data from request to CDP');
                console.log(data);

                // Get selected product variant ID from the form
                let selectedVariantId = null;
                if (window.ShopifyAnalytics.meta.selectedVariantId) {
                    selectedVariantId = parseInt(window.ShopifyAnalytics.meta.selectedVariantId);
                }
                else {
                    const selectedVariantElement = document.querySelector("form.product-form input[name='id']");
                    if (selectedVariantElement) {
                        selectedVariantId = parseInt(selectedVariantElement.value);
                    }
                    else {
                        console.log('No variants selected for this product');
                        return;
                    }
                }

                // Find first variant available for companion product
                const firstAvailableCompanionVariant = data.variants.find(function (variant) {
                    return variant.available;
                });
                if (!firstAvailableCompanionVariant) {
                    console.log('No variants available for companion product');
                    return;
                }

                const companionVariantId = firstAvailableCompanionVariant.id;

                const cartData = {
                    'items': [{
                        'id': selectedVariantId,
                        'quantity': 1
                    }, {
                        'id': companionVariantId,
                        'quantity': 1
                    }]
                };

                console.log('Data for adding products to the cart');
                console.log(cartData);

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify(cartData)
                })
                .then(function (responseCart) {
                    console.log(responseCart);
                    if (responseCart.ok) {
                        location.reload();
                        return;
                    }
                    else {
                        return responseCart.json().
                            then(function (jsonResponseCart) {
                                console.log('Something went wrong when adding products to cart');
                                console.log(jsonResponseCart);
                                if (jsonResponseCart.status === 422) {
                                    window.location.href = '/cart';
                                }
                            });
                    }
                })
                .catch((error) => {
                    console.error('ERROR when trying to add products to cart:', error);
                });
            });
        }

    }
};

function getJSON(url, callback) {
    console.log('Llamada usando la función getJSON() a la URL: ' + url);
    const method = 'GET';
    const xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.responseType = 'json';
    xhr.onload = function () {
        var status = xhr.status;
        if (status === 200) {
            callback(null, xhr.response);
        } else {
            callback(status, xhr.response);
        }
    };
    xhr.send();
};

function int_IsElement(obj) {
    try {
        //Using W3 DOM2 (works for FF, Opera and Chrome)
        return obj instanceof HTMLElement || obj instanceof HTMLFormElement;
    }
    catch (e) {
        //Browsers not supporting W3 DOM2 don't have HTMLElement and
        //an exception is thrown and we end up here. Testing some
        //properties that all elements have (works on IE7)
        return (typeof obj === "object") &&
            (obj.nodeType === 1) && (typeof obj.style === "object") &&
            (typeof obj.ownerDocument === "object");
    }
}

function intelia_show_related_block(element) {
    console.log('Inicializa el elemento del bloque de recomendaciones ID: ' + element.id);
    const block = element.dataset.block;
    const visible = element.dataset.visible;
    InteliaApp.relatedBlocks.show(block, element, visible);
}

function intelia_init_related_block(element) {

    console.log('Inicializando elemento intelia...');

    if (!int_IsElement(element)) {
        console.log('ERROR: No es un elemento válido');
        console.log(element);
    }
    else {
        console.log('Es un elemento válido');
    }

    //if (initialized_intelia) {
    if (InteliaApp.cartLoaded) {
        console.log('Products already loaded from cart...');
        intelia_show_related_block(element);
    }
    else {
        console.log('Loading products from cart...');
        getJSON('/cart.js',
            function (err, data) {
                if (err !== null) {
                    console.log('Error when loading products from cart: ' + err);
                } else {
                    InteliaApp.params.products = '';
                    Object.entries(data.items).forEach(([key, value]) => {
                        InteliaApp.params.products += "&products[]=" + value.product_id;
                    });
                    //initialized_intelia = true;
                    InteliaApp.cartLoaded = true;
                    InteliaApp.params.token = data.token;

                    intelia_show_related_block(element);
                }
            });
    }
}

function intelia_init_related_blocks() {
    console.log('DOM content loaded');

    InteliaApp.init();

    var element_list = document.querySelectorAll('.intelia-block');
    element_list.forEach(function (element) {
        intelia_init_related_block(element);
    });
}

document.addEventListener('DOMContentLoaded', intelia_init_related_blocks, false);
